import * as Sentry from '@sentry/angular';
import { sentryConfig } from './app/sentry.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app';

// Initialize Sentry before anything else
if (sentryConfig.enabled) {
  Sentry.init(sentryConfig);
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
